export default __webpack_public_path__ + "static/media/thumb3.a61b499f.jpg";